
const BoldError = ({ message }: any) => {
    return message ? <div className="alert alert-danger d-flex justify-content-center" role="alert">
        {message}
    </div> : null;
}
export default BoldError;